export default function description() {
    return (
        <div className="card__description-basic">
            <div className="card__description">
                <p className="card__description-title">
                    Загальна характеристика
                </p>
                <p className="card__description-text">
                    ФОРТЕМ (NS 7883) — це сучасний високопродуктивний гібрид соняшнику, створений для стабільного отримання врожаю в умовах інтенсивного та помірного землеробства. Гібрид ідеально поєднує ранньостиглість, високий потенціал врожайності та потужну стійкість до основних стресових факторів.
                </p>
                <p className="card__description-text">
                    Завдяки адаптації до технології Clearfield®, гібрид забезпечує ефективний контроль бур’янів, що особливо важливо для отримання чистих посівів і максимального розкриття врожайного потенціалу.
                </p>
                <p className="card__description-title">Основні переваги</p>
                <ol className="card__description-list">
                    <li className="card__description-numbering">Високий потенціал урожайності — до 5,0 т/га</li>
                    <li className="card__description-numbering">Ранній гібрид — швидкий старт і стабільне дозрівання</li>
                    <li className="card__description-numbering">Стійкість до 6 рас вовчка (A–F)</li>
                    <li className="card__description-numbering">Висока адаптивність до різних зон вирощування</li>
                    <li className="card__description-numbering">Відмінна посухостійкість</li>
                    <li className="card__description-numbering">Сильний стартовий ріст</li>
                </ol>
                <table className="card__description__table">
                    <tr>
                        <td className="card__description__td">Період вегетації</td>
                        <td className="card__description__th-index">104–106 днів</td>
                    </tr>
                    <tr>
                        <td className="card__description__td">Олійність:</td>
                        <td className="card__description__th-index">49–51%</td>
                    </tr>
                    <tr>
                        <td className="card__description__td card__description__td--link">Висота рослин</td>
                        <td className="card__description__th-index">165–180 см</td>
                    </tr>
                </table>
                <p className="card__description-title">
                    Рекомендації по густоті
                </p>
                <ol className="card__description-list">
                    <li className="card__description-numbering">За достатнього зволоження: 55–60 тис. рослин/га</li>
                    <li className="card__description-numbering">У посушливих умовах: 45–50 тис. рослин/га</li>
                </ol>
                <div className="card__description-title">Стійкість та толерантність</div>
                <ol className="card__description-list">
                    <p className="card__description-text">
                        Стійкість:
                    </p>
                    <li className="card__description-numbering">Вилягання — 9/10</li>
                    <li className="card__description-numbering">Посухостійкість — 9/10</li>
                    <li className="card__description-numbering">Холодостійкість — 8/10</li>
                    <p className="card__description-text">
                        Толерантність до хвороб:
                    </p>
                    <li className="card__description-numbering">Пероноспороз, біла та вугільна гнилі, фомопсис, несправжня борошниста роса — висока (9/10)</li>
                    <li className="card__description-numbering">Іржа, сіра гниль, септоріоз, альтернаріоз — висока (8/10)</li>
                </ol>
                <div className="card__description-title">Рекомендовані зони вирощування</div>
                <p className="card__description-text">
                    Гібрид показує найкращі результати в умовах Лісостепу та Степу України, а також може вирощуватись у більш складних регіонах за дотримання технології та сівозміни.
                </p>
                <div className="card__description-title">Рекомендації щодо вирощування</div>
                <p className="card__description-text">
                    ФОРТЕМ добре реагує на інтенсивні технології вирощування, але водночас демонструє стабільність і в умовах обмеженого вологозабезпечення. Рекомендується дотримання класичної сівозміни та використання гербіцидів системи Clearfield® для максимального контролю бур’янів.
                </p>
                <p className="card__description-text">
                    ФОРТЕМ — це ідеальний вибір для аграріїв, які шукають ранній, стабільний та максимально адаптивний гібрид з високим рівнем захисту від вовчка та хвороб. Оптимально підходить як для інтенсивних господарств, так і для регіонів з ризикованим землеробством.
                </p>
            </div>
            <div className="card__description-preference">
                <div className="aside__title--new">Головні переваги</div>
                <div className="asede__head">
                    <div className="aside__block">Високий потенція урожайності</div>
                    <div className="aside__block">Найкращу віддачу забезпечує на родючих грунтах</div>
                    <div className="aside__block">Один із найбільш високоврожайних гібридів з високим вмістом олії</div>
                </div>
            </div>
        </div>
    );
}
